import { useQuery } from '@tanstack/react-query';

import { request } from '@paid-ui/utils/axios';

interface UserEmailCheckParams {
  email: string;
}
type UserEmailCheckResponse = { data: boolean } | null;

export const useUserEmailCheck = (params: UserEmailCheckParams) => {
  const { email } = params;

  return useQuery({
    retry: false,
    enabled: false,
    queryKey: ['UserEmailCheck', email],
    queryFn: async ({ signal }) => {
      const { data } = await request.get<UserEmailCheckResponse>('/users/check', {
        signal,
        params: {
          email: email.trim(),
        },
      });
      return data?.data;
    },
  });
};
